import * as gemini from "gemini/gemini.web";
import {  objEqual } from '../../js/util';
import { paramToOpt, optToParam } from "../../js/recomControl"

export async function showKeyframeModal() {
  const sSpec = this.state.sequence[0],
   eSpec = this.state.sequence[this.state.sequence.length-1],
   opt = paramToOpt(this.state.keyframeModal.params);

  if (objEqual(this.state.keyframeModal.sSpec, sSpec) &&
    objEqual(this.state.keyframeModal.eSpec, eSpec)) {
    this.setState({ keyframeModalShow: true });
  } else {
    await updateKeyframeRecoms.bind(this)(sSpec, eSpec, opt)
  }


}
async function updateKeyframeRecoms(sSpec, eSpec, opt) {

  let recomsPerPath = await gemini.recommendWithPath(sSpec, eSpec, opt)


  let newKeyframeModalState = {
    sSpec,
    eSpec,
    params: optToParam(opt),
    recoms: recomsPerPath
  }

  await this.setState({
    keyframeModal: newKeyframeModalState,
    keyframeModalShow: true,
    recomParameters: {...this.state.recomParameters, dataJoinKey: newKeyframeModalState.params.dataJoinKey}
  });
}
export function onKeyframeModalHide() {
  this.setState({ keyframeModalShow: false });
}

export async function onKeyframeRecomParamChange(newParam) {
  let newKeyframeModal = { ...this.state.keyframeModal }
  newKeyframeModal.params = {
    ...newKeyframeModal.params,
    ...newParam
  };

  const sSpec = newKeyframeModal.sSpec,
   eSpec = newKeyframeModal.eSpec,
   opt = paramToOpt(newKeyframeModal.params);
  await updateKeyframeRecoms.bind(this)(sSpec, eSpec, opt)

}

export function isKeyframeRecommendable(sequence) {
  const sSpec = sequence[0],
    eSpec = sequence[sequence.length-1];

  let recommendable = gemini.canRecommendKeyframes(sSpec, eSpec);

  return recommendable.result;
}